import { Col, Row } from "react-bootstrap";
import ClientsList from "../components/admin/clients/ClientList";
import AdminLayout from "./layout/AdminLayout";
const ManageClient = () => {
  return (
    <AdminLayout>
      <Row>
        <Col className="container">
          <ClientsList />
        </Col>
      </Row>
    </AdminLayout>
  );
};

export default ManageClient;
